// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3NWeJ","large":"styles_large__3QXMP"};